import * as React from "react";
import { styled, useTheme } from "@mui/material/styles";
// import "./Sidebar.css";
import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";
import {
  Box,
  Drawer,
  CssBaseline,
  AppBar as MuiAppBar,
  Toolbar,
  List,
  Typography,
  IconButton,
  ListItem,
  ListItemButton,
  ListItemText,
  Grid,
} from "@mui/material";

import {
  Menu as MenuIcon,
  ChevronLeft as ChevronLeftIcon,
  ChevronRight as ChevronRightIcon,
} from "@mui/icons-material";

import { Link, useLocation } from "react-router-dom";
import CustomHeader from "./Header";
import { Constants } from "../../constants/Constants";

// Import SVGs
import DashboardIcon from "../../Assests/DashboardIcon.svg";
import callCenterIcon from "../../Assests/callCenterIcon1.svg";
import serviceCenter from "../../Assests/serviceCenterIcon1.svg";
import InventoryIcon from "../../Assests/InventoryIcon.svg";
import jobsupload from "../../Assests/jobsupload.svg";
import cannablize from "../../Assests/cannablize.svg";
import helpIcon from "../../Assests/helpIcon2.svg";
import Reports from "../../Assests/report.svg";
// import userImage from "../../Assests/userImage.png";
import userImage from "../../Assests/nuralLogo.png";

const logo = localStorage.getItem("logo");


// Constants
const drawerWidth = 255;

// Styled Components
const Main = styled("main", { shouldForwardProp: (prop) => prop !== "open" })(
  ({ theme, open }) => ({
    flexGrow: 1,
    padding: theme.spacing(0),
    paddingRight: 0, // Remove right padding
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: `-${drawerWidth}px`,
    marginRight: 0, // Explicitly set right margin to 0
    ...(open && {
      transition: theme.transitions.create(["margin", "width"], {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: 0,
    }),
    width: "100%", // Set to 100% for both states
    boxSizing: "border-box", // Ensure padding is included in width calculation
  })
);

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  background:
    "linear-gradient(89.81deg, #33499F 0%, #169AC4 86.91%, #05CFD3 100%)",
  transition: theme.transitions.create(["margin", "width"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  width: open ? `calc(100% - ${drawerWidth}px)` : "100%",
}));

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 0),
  ...theme.mixins.toolbar,
  justifyContent: "flex-end",
}));

// Route Configuration
const navRoutes = [
  {
    label: Constants.superAdmin,
    urls: [
      "/dashboardsuperadmin",
      "/financialdashboard",
      "/createorganizations",
      "/dashboardtrails",
      "/createpackage",
    ],
    icon: DashboardIcon,
    showForEntityType: "superAdmin", // Add condition for showing this route
  },
  {
    label: Constants.dashboard,
    urls: [
      "/dashboard",
      // "/call-dashboard",
      "/amcdashboard",
      "/inventory-dashboard",
      "/service-dashboard",
    ],
    icon: callCenterIcon,
  },
  {
    label: Constants.callDashboard,
    url: "/call-dashboard",
    icon: callCenterIcon,
  },
  {
    label: Constants.customer,
    url: "/Searchdealercustomer",
    icon: jobsupload,
  },
  {
    label: Constants.jobsheetSearch,
    url: "/Jobsheetsearch",
    icon: serviceCenter,
  },
  {
    label: Constants.inventory,
    urls: ["/inventory-stockgrn", "/inventory-stocktransfer"],
    icon: InventoryIcon,
  },
  {
    label: Constants.reports,
    urls: [
      "/jobreport",
      "/Closecallreport",
      "/Callupdationmobile",
      "/Engineerpartconsumption",
      "/Stockinhand",
    ],
    icon: Reports,
  },
  {
    label: Constants.help,
    urls: ["/Changepassword", "/Changeadminpassword"],
    icon: helpIcon,
  },
];

// Main Component
export default function Sidebar({ children }) {
  const [open, setOpen] = React.useState(() => {
    const savedState = localStorage.getItem("sidebarOpen");
    return savedState === null ? false : JSON.parse(savedState);
  });

  const [loginTime] = React.useState(() => {
    return new Date().toLocaleString();
  });

  const theme = useTheme();
  const location = useLocation();
  const currentPath = location.pathname;
  
  // Get entityType inside component to make it reactive
  const entityType = localStorage.getItem("entityType");

  // Filter routes based on entityType
  const filteredNavRoutes = navRoutes.filter(route => {
    // If route has showForEntityType property, check if it matches current entityType
    if (route.showForEntityType) {
      return route.showForEntityType === entityType;
    }
    // If no showForEntityType specified, show for all entity types
    return true;
  });

  const handleDrawerOpen = () => {
    setOpen(true);
    localStorage.setItem("sidebarOpen", "true");
  };

  const handleDrawerClose = () => {
    setOpen(false);
    localStorage.setItem("sidebarOpen", "false");
  };

  return (
    <Grid>
      <Box sx={{ display: "flex", height: "100vh" }}>
        <CssBaseline />

        {/* App Bar */}
        <AppBar position="fixed" open={open}>
          <Toolbar>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={handleDrawerOpen}
              edge="start"
              sx={{
                mr: 2,
                ...(open && { display: "none" }),
                "&:focus, &:focus-visible": { outline: "none" },
              }}
            >
              <MenuIcon />
            </IconButton>
            <CustomHeader />
          </Toolbar>
        </AppBar>

        {/* Drawer */}
        <Drawer
          sx={{
            width: drawerWidth,
            flexShrink: 0,
            "& .MuiDrawer-paper": {
              width: drawerWidth,
              boxSizing: "border-box",
              backgroundColor: "#EFF3FE",
            },
          }}
          variant="persistent"
          anchor="left"
          open={open}
        >
          {/* Drawer Header */}
          <DrawerHeader>
            <IconButton
              onClick={handleDrawerClose}
              sx={{ "&:focus, &:focus-visible": { outline: "none" } }}
            >
              {theme.direction === "ltr" ? (
                <ChevronLeftIcon />
              ) : (
                <ChevronRightIcon />
              )}
            </IconButton>
          </DrawerHeader>

          {/* User Info */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "0px",
              textAlign: "center",
              mb: 2,
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: 0,
                margin: "-20px",
              }}
            >
              <img
                src={logo? logo : userImage}
                alt="company-image"
                style={{ width: "300px", height: "150px", display: "block" }}
              />
            </Box>
            <Box sx={{ mt: "20px" }}>
              <Typography variant="h6">Nural </Typography>
            </Box>
            <Box sx={{ fontSize: "14px", fontWeight: 600, mt: 1 }}>
              <span>
                {Constants.lastLogin}: {loginTime}
              </span>
            </Box>
          </Box>

          {/* Navigation List */}
          <List sx={{ marginTop: "-10px" }}>
            {filteredNavRoutes.map((route) => {
              console.log("route", route);
              const isActive = Array.isArray(route.urls)
                ? route.urls.some((url) => currentPath === url)
                : currentPath === route.url;

              return (
                <ListItem key={route.label} disablePadding >
                  <Link
                    to={route.urls ? route.urls[0] : route.url}
                    style={{ 
                      textDecoration: "none",
                      width: "100%",
                      color: "black",
                    }}
                  >
                    <ListItemButton
                      selected={isActive}
                      sx={{
                        "&.Mui-selected": {
                          background:
                            "linear-gradient(89.81deg, rgb(51 73 159) 0%, rgb(24 148 193) 86.91%, rgb(5 205 210) 100%)",
                          "&:hover": {
                            backgroundColor: "rgba(220, 228, 255, 0.3)",
                          },
                          "& .MuiTypography-body1": {
                            color: "white !important",
                            fontWeight: "600",
                          },
                        },
                      }}
                    >
                      <img
                        src={route.icon}
                        style={{ marginRight: "20px" }}
                        alt={route.label}
                      />
                      <ListItemText primary={route.label} />
                    </ListItemButton>
                  </Link>
                </ListItem>
              );
            })}
          </List>
        </Drawer>

        {/* Main Content */}
        <Main open={open}>
          <DrawerHeader />
          {children}
        </Main>
      </Box>
    </Grid>
  );
}
